import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-input-label[controlId][controlLabel][required]',
    templateUrl: './input-label.component.html',
    styleUrls: ['./input-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputLabelComponent implements OnInit {

  @Input() controlId!: string;
  @Input() controlLabel!: string;
  @Input() required!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
